module.exports = __webpack_public_path__ + "img/MonstersGuidetoShyness-Cover-640.8301d35a.png";